import React, { useMemo, useState } from "react";

function YouTubeEmbed({ url }) {
  const [isLoaded, setIsLoaded] = useState(false);

  const id = useMemo(() => {
    if (!url) return null;
    const match = url.match(
      /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([0-9A-Za-z_-]{11})/,
    );
    return match ? match[1] : null;
  }, [url]);

  if (!id) {
    return (
      <a href={url} target="_blank" rel="noreferrer">
        {url}
      </a>
    );
  }

  const embed = `https://www.youtube-nocookie.com/embed/${id}?rel=0&modestbranding=1`;
  const thumbnail = `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;

  if (!isLoaded) {
    return (
      <button
        type="button"
        onClick={() => setIsLoaded(true)}
        style={{
          position: "relative",
          width: "100%",
          aspectRatio: "16 / 9",
          border: "none",
          borderRadius: 8,
          overflow: "hidden",
          padding: 0,
          cursor: "pointer",
          backgroundColor: "#000",
          backgroundImage: `url(${thumbnail})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        aria-label="Load YouTube video"
      >
        <span
          style={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(to top, rgba(0,0,0,0.55), rgba(0,0,0,0.15))",
          }}
        />
        <span
          style={{
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            width: 64,
            height: 44,
            borderRadius: 12,
            background: "rgba(255, 0, 0, 0.95)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 6px 24px rgba(0,0,0,0.35)",
          }}
        >
          <span
            style={{
              width: 0,
              height: 0,
              borderTop: "10px solid transparent",
              borderBottom: "10px solid transparent",
              borderLeft: "16px solid #fff",
              marginLeft: 4,
            }}
          />
        </span>
      </button>
    );
  }

  return (
    <div style={{ position: "relative", paddingTop: "56.25%" }}>
      <iframe
        src={embed}
        title={`YouTube video ${id}`}
        frameBorder="0"
        loading="lazy"
        referrerPolicy="strict-origin-when-cross-origin"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          borderRadius: 8,
        }}
      />
    </div>
  );
}

export default React.memo(YouTubeEmbed);
